import { combineReducers } from 'redux';

// reducer import
import authReducer from './authReducer';
import customizationReducer from './customizationReducer';
import menuReducer from './menuReducer';
import breadcrumbReducer from './breadcrumbReducer';
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    auth: authReducer,
    menu: menuReducer,
    breadcrumbs: breadcrumbReducer
});

export default reducer;
